import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Footer() {
  return (
    <footer className="bg-foreground-950 text-background-50">
      <div className="w-full max-w-[1280px] mx-auto px-4 md:px-6">
        {/* Main Footer */}
        <div className="py-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          {/* Brand */}
          <div>
            <Link to="/" className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 rounded-lg bg-primary-500 flex items-center justify-center">
                <i className="ri-book-read-line text-background-50 text-lg"></i>
              </div>
              <span className="font-heading text-xl font-bold text-background-50">
                歪歪漫画
              </span>
            </Link>
            <p className="text-sm text-background-50/60 leading-relaxed">
              歪歪漫画网汇集最新高清免费韩国漫画大全，主打热门无删减韩漫在线阅读，为您呈现原汁原味的韩国漫画作品库。
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">快速链接</h4>
            <ul className="space-y-2.5">
              <li>
                <Link to="/" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">
                  首页
                </Link>
              </li>
              <li>
                <Link to="/about" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">
                  关于我们
                </Link>
              </li>
              <li>
                <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">
                  更新日志
                </a>
              </li>
              <li>
                <a href="#" className="text-sm text-background-50/60 hover:text-primary-400 transition-colors">
                  帮助中心
                </a>
              </li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">热门分类</h4>
            <div className="flex flex-wrap gap-2">
              {categories.slice(0, 6).map((cat) => (
                <Link
                  key={cat.slug}
                  to={`/category/${cat.slug}`}
                  className="px-3 py-1.5 text-xs rounded-full bg-background-50/10 text-background-50/70 hover:bg-primary-500 hover:text-background-50 transition-colors whitespace-nowrap"
                >
                  {cat.name}
                </Link>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-base font-semibold text-background-50 mb-4">联系我们</h4>
            <ul className="space-y-2.5">
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-mail-line text-primary-400"></i>
                <span>contact@waiwaimanhua.com</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-customer-service-line text-primary-400"></i>
                <span>在线客服：工作日 9:00-18:00</span>
              </li>
              <li className="flex items-center gap-2 text-sm text-background-50/60">
                <i className="ri-map-pin-line text-primary-400"></i>
                <span>中国·北京</span>
              </li>
            </ul>
            <div className="flex gap-3 mt-4">
              <a href="#" className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微博">
                <i className="ri-weibo-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="微信">
                <i className="ri-wechat-line text-sm"></i>
              </a>
              <a href="#" className="w-8 h-8 rounded-full bg-background-50/10 flex items-center justify-center hover:bg-primary-500 transition-colors" aria-label="QQ">
                <i className="ri-qq-line text-sm"></i>
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-background-50/10 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; 2026 歪歪漫画网 WaiwaiManhua.com - 最新高清免费韩国漫画大全
          </p>
          <div className="flex items-center gap-4">
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors">
              隐私政策
            </a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors">
              服务条款
            </a>
            <a href="#" className="text-xs text-background-50/40 hover:text-background-50/70 transition-colors">
              DMCA
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}